import React, { useEffect, useRef, useState } from "react";
import { Toolbar } from 'primereact/toolbar';
import { InputText } from "primereact/inputtext";
import { Buttons, classNames, useDebounce, useClickOutside, Menu, Popover, ToolTip } from 'az-platform-ui';
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { FilterGroupAtom, authenticate, searchTextAtom } from "../Recoil-State";
import API from "../Pages/API-Services";

const ptMenu = {
    root: { className: 'w-7rem' },
    menuitem: { className: 'p-0' }
}
const userMenuPt = {
    menuitem: { className: 'p-0 text-xs' } 
}
const StartContent = () => {
    return (
        <div className=" pl-3 pr-3 flex flex-row  justify-content-center	align-items-center ">
            <div className="w-6rem space-left"> &nbsp; &nbsp;</div>
            <div className='logo text-white'> Field Excellence Platform </div>
        </div>)
}

const getNameInitials = (firstName, lastName) => {
    if (!firstName || !lastName) return "";
    if (firstName?.length > 0 && lastName?.length > 0) return firstName[0] + lastName[0];
    return "";
}


const EndContent = ({ doAction, isSearch }) => {
    const user = useRecoilValue(authenticate);
    const nameDisplay = getNameInitials(user?.firstName, user?.lastName);
    const userMenu = useRef();
    const [enableProfileMenu, setEnableProfileMenu] = useState();
    const BaseURL = window.location.origin;
    const items = [
        { icon: 'pi pi-user' , label: user?.firstName + ' ' + user?.lastName, 
                template: () => (<div className="flex flex-row gap-1 pl-3 text-xs pt-1 pb-1 color-fav"> 
                        <i className="pi pi-user"/>
                        <div className="flex flex-column pl-1 ">
                        <span className="font-medium"> {user?.firstName} {user?.lastName} </span> 
                        <span> ({user?.userName})</span>
                       
                        </div>
                        
                    </div>)  },
        { icon: 'pi pi-question-circle' , label: 'Help'},
        { icon: 'pi pi-cog' , label: 'Settings'},
    ]
    
    const handleSignOut = () => {
        const callLogout = API.httpService.logout();
    }

    const ProfileMenuFooter = () => (
        <div className="w-full flex flex-row justify-content-start ">
            <a className="w-full text-gray-900 p-2 no-underline flex justify-content-start cursor-pointer signout-footer">
                <div className="flex flex-row ustify-content-center align-items-center py-1 text-center signout"
                    onClick={handleSignOut}
                >
                    <span className="pr-2"><i className="text-sm pi pi-sign-out rotate-180" /></span>
                    <span className="signOut font-normal">Sign out</span>
                </div>
            </a>
        </div>
    );

    const ProfileLogo = ({ initials }) => {
        return (
            <div className={`profile-logo-bg border-circle font-medium text-white flex align-items-center justify-content-center w-4rem h-4rem text-4xl`}>
                {initials}
            </div>
        );
    }

    return (
        <div className='flex flex-row  justify-content-center	align-items-center header-height'>
            <Menu ref ={userMenu} popupAlignment="right" model={items} popup  pt ={userMenuPt} />

            {/* <Buttons icon="pi pi-bell text-xl text-white on-Mobile mr-3" size="small" rounded text />
            <Buttons icon={classNames("pi text-xl text-white on-Mobile", { 'pi-times': isSearch }, { 'pi-search': !isSearch })} size="small" rounded text onClick={() => doAction('search')} /> */}

            {/* <Buttons  className='on-Mobile' size="small" rounded text onClick={(event) => userMenu.current.toggle(event)}  >
                <div className=" flex flex-row align-items-center justify-content-center">
                    <Avatar image={"https://cdn.pixabay.com/photo/2021/04/20/07/59/woman-6193184_1280.jpg"} shape="circle" className="border-circle h-2rem w-2rem" />
                    <i className="pi pi-ellipsis-v text-white " />
                </div>
            </Buttons> */}

            <div className="on-desktop mr-3 flex flex-row  justify-content-center	align-items-center pr-3 header-height">
                {/* <Buttons icon="pi pi-bell text-xl text-white " className="mr-3  " size="small" rounded text />
                <Buttons icon="pi pi-cog text-xl text-white	" className="mr-3" size="small" rounded text />
                <Buttons icon="pi pi-question-circle text-xl text-white	" size="small" className="mr-3" rounded text /> */}
                
                {/* profile menu */}
                <>
                    <div
                        className="flex align-items-center justify-content-center cursor-pointer select-none pl-2 pr-3 py-1"
                        onClick={(e) => {
                            e.preventDefault();
                            setEnableProfileMenu(e);
                        }}
                    >
                        {user && <div className={`profile-logo-bg border-circle font-medium text-white w-2rem h-2rem flex align-items-center justify-content-center`}>
                            {nameDisplay}
                        </div>}
                        {!user && <img src={"https://dummyimage.com/900x400/cfcfcf/fff.png&text=this+is+dummy+image"} alt="" className='w-2rem h-2rem  object bg-cover' />}
                    </div>
                    <Popover
                        dismissable={true}
                        isToggle={enableProfileMenu} // toggle state of popover
                        footer={<ProfileMenuFooter />} // Footer of Popover
                        className='mt-2 w-18rem select-none' // root class name for popover
                        contentClassName={'p-0 mt-3 '} // body class name for popover 
                    >
                        {user && <div className="flex flex-row" >
                            <div className="pl-2 pt-1 h-full flex align-items-center" style={{color: '#303131'}}>
                                <ProfileLogo initials={nameDisplay} />
                            </div>
                            <div className="pl-3 mb-3 flex flex-column align-items-start">
                                <ToolTip tooltip={`${user?.lastName}, ${user?.firstName}`} position={'bottom'}>
                                    <div className="username text-base font-medium pb-1 overflow-hidden text-overflow-ellipsis w-12rem white-space-nowrap" style={{ color: '#303131'}}>
                                        <span>{user?.lastName}, {user?.firstName}</span>
                                    </div>
                                </ToolTip>
                                <ToolTip tooltip={user?.email} position={'bottom'}>
                                    <div className='prid overflow-hidden text-overflow-ellipsis font-light w-12rem pb-1' style={{color: '#303131'}}>{user?.email}</div>
                                </ToolTip>
                                <div className='text-500 prid'><i>ID: {user?.userName}</i></div>
                            </div>
                        </div>}
                    </Popover>
                </>
            </div>
        </div>
    )
}

export const SearchContent = ({ doChange, searchText, isMobile }) => {
    const [filters, setFilters] = useRecoilState(FilterGroupAtom)
    const { filterData, active, isActiveFilter } = filters || {};
    const filterObj = filterData?.find(e => e.value === active);
    const menuLeft = useRef(null);
    const overlayRef = useRef(null);
    const inputRef = useRef(null);

    useClickOutside(overlayRef, () => setFilters({ ...filters, isActiveFilter: false }));

    const onChangeFilter = ({ item }) => setFilters((prev) => ({ ...prev, active: item?.value }));
    const onHide = () => setTimeout(() => inputRef?.current?.focus(), 10);

    const itemTemplate = (item, props) => {
        return (
            <div className='p-menuitem-content' onClick={props?.element?.props?.onClick}>
                <a className="flex align-items-center p-menuitem-link p-2 pl-3 color-fav text-xs font-medium"> {item.label} </a>
            </div>
        );
    }

    let items = filterData?.map(e => ({ label: e.label, value: e?.value, command: onChangeFilter, template: itemTemplate }));
    return (
        <span className={classNames({ 'is-mobile-search block shadow-2	': isMobile }, "p-input-icon-left w-28rem w-full search-content")} ref={overlayRef} >
            <i className="pi pi-search z-1 text-color-500 pl-2 text-500" />
            <InputText ref={inputRef} placeholder={'Search'} className="w-full pr-5 " onFocus={() => setFilters({ ...filters, isActiveFilter: true })} value={searchText} onChange={(e) => doChange(e.target.value)} />
            {filterData && <Menu popupAlignment="right" onHide={onHide} model={items} popup ref={menuLeft} pt={ptMenu} className="" />}

            <div className='flex flex-row gap-2 filter-group-button absolute right-0 top-0 mt-2 mr-2 justify-content-center	 align-items-center'>
                {searchText && <i className="pi pi-times cursor-pointer text-500" onClick={() => doChange('')} />}
                {isActiveFilter && <Buttons size="small" onClick={(event) => menuLeft.current.toggle(event)} outlined className={classNames('p-1 text-xs active ')}> {filterObj?.label} <i className="pi pi-angle-down text-xs ml-1" /> </Buttons>}
            </div>

        </span>
    )
}

export const PageHeader = ({ title }) => {
    const [searchText, debouncedSearchText, setInputValue] = useDebounce('', 500);
    const [isSearch, setIsSearch] = useState(false);
    const setSearchText = useSetRecoilState(searchTextAtom);
    useEffect(() => setSearchText(debouncedSearchText), [debouncedSearchText]);
    const doChange = (val) => setInputValue(val);

    const doAction = (action) => {
        if (action === 'search') {
            setIsSearch(e => (!e));
        }
    }
    return (
        <Toolbar 
        style={{ backgroundImage: 'url(images/logo-bg.png)' }} 
        start={<StartContent />} 
        center={<SearchContent searchText={searchText} doChange={doChange} isMobile={isSearch} />} 
        end={<EndContent isSearch={isSearch} doAction={doAction} />} 
        className='shadow-2 p-0 border-none border-noround image-100  border-transparent	' 
        />
    )
}